import axios from "axios";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Custom log function
import { auth, dbCentral } from "../../config/FirebaseConfig";

const refreshFileUrl = async (id, token, prefix) => {
  try {
    // send a simple post request to the server to refresh the file URL
    const url = `${prefix}upload/refresh-file-url`;
    const body = {
      id: id,
    };
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const response = await axios.post(url, body, { headers });
    const responseText = await response.data;
    const new_url = responseText.url;
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User is not authenticated");
      return;
    }
    if (response.status === 200) {
      // Log the successful response
      const db = getFirestore();
      const userRef = doc(db, "user", currentUser.uid);
      const userSnapshot = await getDoc(userRef);
      if (!userSnapshot.exists()) {
        console.error("User document not found");
        return;
      }
      const org_id = userSnapshot.get("org_id");
      await addLogDocument(
        url,
        prefix,
        userRef,
        org_id,
        response.status.toString(),
        "",
        "",
        JSON.stringify(body),
        responseText,
        "POST"
      );
      return new_url;
    } else {
      console.error(`Error refreshing file URL: ${response.status}`);
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
  }
  return null; // Return null if an error occurs
};
export default refreshFileUrl;
